<div *ngIf="!isCookie && !isIframe" id="cky-consent-container" [ngClass]="{'mobile-mode': !isDesktopDevice}" class="text-center">
  <div class="cky-consent-bar">
    <div class="cky-notice">
      <p class="cky-title">We value your privacy</p>
      <div class="cky-notice-group">
        <div class="cky-notice-des">
          <p>
            We use cookies to enhance your browsing experience, serve
            personalized ads or content, and analyze our traffic. By clicking
            "Accept All", you consent to our use of cookies.
          </p>
        </div>
        <div class="cky-notice-btn-wrapper">
          <button
            class="cky-btn cky-btn-customize"
            (click)="openCookiesCenter()"
          >
            Customize
          </button>
          <button class="cky-btn cky-btn-reject" (click)="saveCookies(false)">
            Reject All
          </button>
          <button class="cky-btn cky-btn-accept" (click)="saveCookies(true)">
            Accept All
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="cookiesCenter"
  id="cookiescenter-modal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title text-center" id="gridSystemModalLabel">
          Cookies Settings Center
        </h4>
        <button
          type="button"
          class="btn-close"
          data-dismiss="modal"
          (click)="closeCookiesCenter()"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <p class="cky-preference-content-wrapper">
          We use cookies to help you navigate efficiently and perform certain
          functions. You will find detailed information about all cookies under
          each consent category below.
        </p>
        <p>
          The cookies that are categorized as "Necessary" are stored on your
          browser as they are essential for enabling the basic functionalities
          of the site.
        </p>
        <div class="cky-preference-content-wrapper">
          <label id="label-technical"
            ><i class="fa fa-check"></i
            ><b class="bold-statistics">Necessary </b></label
          ><br />
          <p style="padding-left: 30px">
            Necessary cookies are required to enable the basic features of this
            site, such as providing secure log-in or adjusting your consent
            preferences. These cookies do not store any personally identifiable
            data.
          </p>
        </div>
        <div class="cky-preference-content-wrapper">
          <label id="label-statistics">
            <input
              type="checkbox"
              class="input"
              id="analyticsCookies-input"
              [checked]="saveAnalyticsCookie"
              (change)="saveAnalyticsCookie = !saveAnalyticsCookie"
            />
            <b class="bold-statistics">Analytics</b>
          </label>
          <br />
          <p style="padding-left: 30px">
            Analytical cookies are used to understand how visitors interact with
            the website. These cookies help provide information on metrics such
            as the number of visitors, bounce rate, traffic source, etc.
          </p>
          <div class="cookies-tbl-wrp">
            <table class="cookies-tbl">
              <tbody>
                <tr>
                  <td>Cookie</td>
                  <td>_gid</td>
                </tr>
                <tr>
                  <td>Duration</td>
                  <td>1 day</td>
                </tr>
                <tr>
                  <td>Description</td>
                  <td>
                    Google Analytics sets this cookie to store information on
                    how visitors use a website while also creating an analytics
                    report of the website's performance. Some of the collected
                    data includes the number of visitors, their source, and the
                    pages they visit anonymously.
                  </td>
                </tr>
              </tbody>
            </table>
            <table class="cookies-tbl">
              <tbody>
                <tr>
                  <td>Cookie</td>
                  <td>_gat_gtag_UA_*</td>
                </tr>
                <tr>
                  <td>Duration</td>
                  <td>1 minute</td>
                </tr>
                <tr>
                  <td>Description</td>
                  <td>
                    Google Analytics sets this cookie to store a unique user ID.
                  </td>
                </tr>
              </tbody>
            </table>
            <table class="cookies-tbl">
              <tbody>
                <tr>
                  <td>Cookie</td>
                  <td>_ga_*</td>
                </tr>
                <tr>
                  <td>Duration</td>
                  <td>1 year 1 month 4 days</td>
                </tr>
                <tr>
                  <td>Description</td>
                  <td>
                    Google Analytics sets this cookie to store and count page
                    views.
                  </td>
                </tr>
              </tbody>
            </table>
            <table class="cookies-tbl">
              <tbody>
                <tr>
                  <td>Cookie</td>
                  <td>_ga</td>
                </tr>
                <tr>
                  <td>Duration</td>
                  <td>1 year 1 month 4 days</td>
                </tr>
                <tr>
                  <td>Description</td>
                  <td>
                    Google Analytics sets this cookie to calculate visitor,
                    session and campaign data and track site usage for the
                    site's analytics report. The cookie stores information
                    anonymously and assigns a randomly generated number to
                    recognise unique visitors.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer text-center justify-space-between">
        <button
          type="button"
          (click)="saveCookies(true)"
          class="cky-btn cky-btn-customize"
          data-dismiss="modal"
        >
          Save my preferences
        </button>
        <button class="cky-btn cky-btn-accept" (click)="saveCookies(true)">
          Accept All
        </button>
      </div>
    </div>
  </div>
</div>
